<template>
  <div>
    <div class="flex justify-between items-center">
      <h1>Users</h1>
      <el-input
        v-model="name"
        style="width: 30%"
        @keyup.native.enter="queryData(1)"
      >
        <el-button slot="append" @click="queryData(1)">Search</el-button>
      </el-input>
    </div>
    <table class="clickable mt-10">
      <thead>
        <th>Name</th>
        <th>Business</th>
        <th>Status</th>
      </thead>
      <tbody>
        <tr
          v-for="user in users.data"
          :key="user.id"
          @click="
            $router.push({ name: 'user-detail', params: { id: user.id } })
          "
        >
          <td>{{ user.firstName }} {{ user.lastName }}</td>
          <td>{{ user.business.name }}</td>
          <td>{{ user.blocked ? "Blocked" : "Not blocked" }}</td>
        </tr>
      </tbody>
    </table>

    <el-pagination
      class="mt-10"
      :current-page="users.pagination.currentPage"
      layout="pager"
      :total="users.pagination.totalCount"
      @current-change="pageChanged"
      :page-size="100"
      hide-on-single-page
    />
  </div>
</template>

<script>
import PaginatedPage from "./PaginatedPage";
import { USERS_QUERY } from "@/api/queries";

export default {
  extends: PaginatedPage,
  apollo: {
    users: {
      query: USERS_QUERY,
      variables() {
        return {
          name: "",
          pagination: { page: 1 }
        };
      }
    }
  },
  watch: {
    name(name) {
      if (name.length == 0) this.queryData(1);
    }
  },
  data() {
    return {
      name: "",
      users: { data: [], pagination: { currentPage: 1, totalCount: 0 } }
    };
  },
  methods: {
    queryData(page) {
      this.$apollo.queries.users.refetch({
        name: this.name,
        pagination: { page }
      });
    }
  }
};
</script>
